/*
 * @Author: Teemo Ding
 * @Date: 2022-03-01 15:59:07
 * @LastEditTime: 2022-03-11 09:10:47
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/communication.ts
 */
import { get, post, remove } from '@/src/tools/server';
export const getCommunicationSettings = (salesChannelUuid) => {
  return get(`/portal/communication/salesChannel/${salesChannelUuid}`, {});
};
export const deleteCommunicationGateway = (salesChannelUuid, gatewayUuid) => {
  return remove(
    `/portal/communication/salesChannel/${salesChannelUuid}/${gatewayUuid}`,
    {},
  );
};

export const addSalesChannelCommunicationGateways = (data) => {
  return post(`/portal/communication/salesChannel/gateways`, data, {});
};

export const changeSimultaneous = (salesChannelUuid, value) => {
  return post(
    `/portal/communication/salesChannel/${salesChannelUuid}/simultaneous/${value}`,
    {},
    {},
  );
};

export const changePriority = (salesChannelUuid, data) => {
  return post(
    `/portal/communication/salesChannel/${salesChannelUuid}/priority`,
    data || {},
    {},
  );
};

export const getTemplateDetail = (salesChannelUuid, category) => {
  return get(
    `/portal/communication/salesChannel/${salesChannelUuid}/template/${category}`,
    {},
  );
};

export const getMpTemplates = (salesChannelUuid) => {
  return get(
    `/portal/communication/salesChannel/${salesChannelUuid}/mpTemplates`,
    {},
  );
};

export const saveTemplate = (salesChannelUuid, data) => {
  return post(
    `/portal/communication/salesChannel/${salesChannelUuid}/template`,
    data,
    {},
  );
};

export const sendMessage = (data) => {
  return post(`/portal/communication/salesChannel/template/test`, data, {});
};
